import React from 'react';
import PropTypes from 'prop-types';

// Multibrand-UI Components
import Button from '@zg-rentals/multibrand-ui/lib/Button';

// Stylesheets
import './style.scss';

const propTypes = {
    buttonText: PropTypes.string.isRequired,
    excelUrl: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
};

const defaultProps = {
    disabled: false,
};

// All excel links are currently external
// TODO: make links more flexible
function AsideAnalytics({ buttonText, excelUrl, disabled }) {
    return (
        <div className="AsideAnalytics">
            <Button
                type="primary"
                data-test="download-excel-button"
                disabled={disabled}
                onClick={() => window.open(excelUrl)}
            >
                {buttonText}
            </Button>
        </div>
    );
}

AsideAnalytics.propTypes = propTypes;
AsideAnalytics.defaultProps = defaultProps;

export default AsideAnalytics;
